import type { AdminDeletionScheduledTemplateData } from '../admin-deletion-scheduled/admin-deletion-scheduled.component';

export const CompanyDeletionScheduledTemplateMocks: AdminDeletionScheduledTemplateData[] = [
  {
    title: 'Your company account [Company_name_here] is scheduled to be deleted in 2 months',
    p1_html:
      'After your subscription has been inactive for more than 6 months, we schedule your company account for automatic deletion. To keep your account, please reactivate your subscription before the deletion date.',
    p2_html: '<b>Scheduled deletion date</b>: 23 Sep 2022',
    button_text: 'See plans',
    button_link: 'http://recruitee.com',
    footer: {
      text: 'Need help?',
      label: 'Contact us',
      href: 'https://auth.recruitee.com/?intercom_open=true',
      target: '_blank',
    },
  },
];
